export default "__VITE_ASSET__857faba1__"